/* Cozfy Sunrise theme — vanilla JS, no dependencies */
(() => {
  const C = window.Cozfy || {};
  const PREVIEW = !!C.preview; // set by preview/index.html only
  const ROOT = ((C.routes && C.routes.root) || '/').replace(/\/?$/, '/');
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = new Intl.NumberFormat(C.locale || 'en', { style: 'currency', currency: C.currency || 'USD' });
  const money = (cents) => fmt.format(cents / 100);

  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };

  /* ---------- Countdown (bar, product page, popup) ---------- */
  const parseEnd = (str) => {
    if (!str) return null;
    const d = new Date(String(str).trim().replace(' ', 'T'));
    return isNaN(d) ? null : d;
  };
  const offerExpired = (str) => {
    const end = parseEnd(str);
    return !end || end.getTime() <= Date.now();
  };

  function initCountdowns() {
    const els = $$('[data-countdown]');
    if (!els.length) return;
    els.forEach((el) => { el._end = parseEnd(el.dataset.end); });
    const tick = () => {
      const now = Date.now();
      els.forEach((el) => {
        const left = el._end ? el._end.getTime() - now : 0;
        if (left <= 0) {
          el.classList.add('is-expired');
          if ('hideExpired' in el.dataset) el.hidden = true;
          return;
        }
        const s = Math.floor(left / 1000);
        const d = Math.floor(s / 86400);
        const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = pad(v); };
        set('[data-cd-d]', d);
        set('[data-cd-h]', Math.floor((s % 86400) / 3600));
        set('[data-cd-m]', Math.floor((s % 3600) / 60));
        set('[data-cd-s]', s % 60);
        const dw = $('[data-cd-days-wrap]', el);
        if (dw) dw.hidden = d === 0;
      });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    const track = $('[data-gallery-track]', g);
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const dots = $$('[data-gallery-dot]', g);
    const thumbs = $$('[data-gallery-thumb]', g.parentElement);
    let idx = 0;
    const mark = (i) => {
      idx = i;
      dots.forEach((d, j) => d.setAttribute('aria-current', j === i));
      thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i));
      slides.forEach((s, j) => { const v = $('video', s); if (v) j === i ? v.play().catch(() => {}) : v.pause(); });
    };
    const go = (i) => {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      mark(i);
    };
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== idx && slides[i]) mark(i);
      });
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    const prev = $('[data-gallery-prev]', g); if (prev) prev.addEventListener('click', () => go(idx - 1));
    const next = $('[data-gallery-next]', g); if (next) next.addEventListener('click', () => go(idx + 1));
    g.goToMedia = (id) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i > -1) go(i);
    };
  }

  /* ---------- Cart helpers ---------- */
  let previewCount = 0;
  async function cartAdd(form) {
    const fd = new FormData(form);
    if (PREVIEW) {
      await new Promise((r) => setTimeout(r, 450));
      previewCount += Number(fd.get('quantity') || 1);
      return { preview: true };
    }
    const res = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
    return data;
  }
  async function refreshCount() {
    let count = previewCount;
    if (!PREVIEW) {
      try { count = (await (await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })).json()).item_count; } catch (e) { return; }
    }
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  /* ---------- Modal helper (popup + cart notice) ---------- */
  function makeModal(root, closeSel) {
    let lastFocus = null;
    const close = () => {
      root.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      setTimeout(() => { root.hidden = true; }, 350);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    };
    const open = () => {
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('no-scroll');
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
      const f = $('a[href], button', $('[role="dialog"]', root));
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
    };
    $$(closeSel, root).forEach((b) => b.addEventListener('click', close));
    root.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    return { open, close, isOpen: () => !root.hidden };
  }

  let cartNotice = null;
  function initCartNotice() {
    const el = $('[data-cart-notice]');
    if (el) cartNotice = Object.assign(makeModal(el, '[data-cart-notice-close]'), { el });
  }
  function showCartNotice({ title, image, meta }) {
    if (!cartNotice) { window.location.href = ROOT + 'cart'; return; }
    const { el } = cartNotice;
    $('[data-cn-title]', el).textContent = title || '';
    $('[data-cn-meta]', el).textContent = meta || '';
    const img = $('[data-cn-img]', el);
    if (image) { img.src = image; img.hidden = false; } else { img.hidden = true; }
    cartNotice.open();
  }

  /* ---------- Product page ---------- */
  function initProduct(pdp) {
    const form = $('[data-product-form]', pdp);
    if (!form) return;
    const variantInput = $('[data-variant-input]', form);
    let variants = [];
    try { variants = JSON.parse($('[data-variants]', pdp).textContent); } catch (e) { /* no json */ }
    let variant = variants.find((v) => String(v.id) === variantInput.value) || variants[0];
    const bundleInputs = $$('[data-bundle-input]', pdp);
    const addBtn = $('[data-add-btn]', form);
    const addLabel = $('[data-add-label]', form);
    const addText = (addBtn && addBtn.dataset.addText) || 'Add to cart';
    const soldOutText = (addBtn && addBtn.dataset.soldoutText) || 'Sold out';
    const qtyInput = $('[data-qty-input]', form);
    const errorEl = $('[data-form-error]', form);
    const gallery = $('[data-gallery]', pdp);

    const bundle = () => {
      const b = bundleInputs.find((i) => i.checked);
      return b ? { qty: Number(b.value), discount: Number(b.dataset.discount || 0) } : { qty: 1, discount: 0 };
    };
    const totalFor = (unit, qty, disc) => Math.round((unit * qty * (100 - disc)) / 100);

    function render() {
      if (!variant) return;
      const unit = variant.price;
      const compare = variant.compare > unit ? variant.compare : unit;
      const pct = compare > unit ? Math.floor(((compare - unit) * 100) / compare) : 0;

      $$('[data-price]', pdp).forEach((e) => { e.textContent = money(unit); });
      $$('[data-compare]', pdp).forEach((e) => { e.textContent = money(compare); e.hidden = !pct; });
      $$('[data-save]', pdp).forEach((e) => { e.textContent = `Save ${pct}%`; e.hidden = !pct; });

      bundleInputs.forEach((inp) => {
        const q = Number(inp.value);
        const t = totalFor(unit, q, Number(inp.dataset.discount || 0));
        const c = compare * q;
        const card = inp.closest('[data-bundle]');
        card.classList.toggle('is-selected', inp.checked);
        $('[data-bundle-price]', card).textContent = money(t);
        $('[data-bundle-compare]', card).textContent = c > t ? money(c) : '';
        $('[data-bundle-save]', card).textContent = c > t ? `You save ${money(c - t)}` : '';
        $('[data-bundle-each]', card).textContent = q > 1 ? `${money(Math.round(t / q))} each` : '';
      });

      const { qty, discount } = bundle();
      if (qtyInput) qtyInput.value = qty;
      $$('[data-btn-price]', pdp).forEach((e) => { e.textContent = money(totalFor(unit, qty, discount)); });

      const ok = !!variant.available;
      if (addBtn) addBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = ok ? addText : soldOutText;
    }

    /* Variant picker */
    const optionInputs = $$('[data-option-index]', pdp);
    optionInputs.forEach((inp) => inp.addEventListener('change', () => {
      const selected = [];
      optionInputs.filter((i) => i.checked).forEach((i) => { selected[Number(i.dataset.optionIndex)] = i.value; });
      const match = variants.find((v) => v.options.every((o, k) => o === selected[k]));
      $$('[data-option-label]', pdp).forEach((l) => { l.textContent = selected[Number(l.dataset.optionLabel)] || ''; });
      if (!match) { variant = Object.assign({}, variant, { available: false }); render(); return; }
      variant = match;
      variantInput.value = match.id;
      if (match.media && gallery && gallery.goToMedia) gallery.goToMedia(match.media);
      if (!PREVIEW) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
      render();
    }));

    bundleInputs.forEach((inp) => inp.addEventListener('change', render));

    /* Add to cart / Buy now */
    const setError = (msg) => { if (!errorEl) return; errorEl.textContent = msg || ''; errorEl.hidden = !msg; };
    async function add(btn) {
      setError('');
      btn.classList.add('is-loading');
      try {
        const data = await cartAdd(form);
        await refreshCount();
        const { qty } = bundle();
        const title = data.product_title || ($('.pdp__title', pdp) || {}).textContent || '';
        const variantTitle = variant ? (variant.options || []).filter((o) => o !== 'Default Title').join(' / ') : '';
        showCartNotice({
          title,
          image: data.image || (($('.gallery__slide img', pdp) || {}).currentSrc || ($('.gallery__slide img', pdp) || {}).src),
          meta: [`Qty ${qty}`, variantTitle, $('[data-btn-price]', pdp) ? $('[data-btn-price]', pdp).textContent : ''].filter(Boolean).join(' · ')
        });
      } catch (err) {
        setError(err.message);
      } finally {
        btn.classList.remove('is-loading');
      }
    }
    form.addEventListener('submit', (e) => { e.preventDefault(); add(addBtn); });

    /* Sticky add-to-cart (mobile) */
    const sticky = $('[data-sticky-atc]', pdp);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const stickyBtn = $('[data-sticky-add]', sticky);
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', () => add(stickyBtn));
    }

    render();
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery() {
    $$('[data-delivery]').forEach((el) => {
      const addBiz = (n) => {
        const d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n -= 1; }
        return d;
      };
      const f = new Intl.DateTimeFormat(C.locale || 'en', { weekday: 'short', month: 'short', day: 'numeric' });
      const out = $('[data-delivery-dates]', el);
      if (out) out.textContent = `${f.format(addBiz(Number(el.dataset.min)))} – ${f.format(addBiz(Number(el.dataset.max)))}`;
    });
  }

  /* ---------- Offer popup ---------- */
  function initPopup() {
    const el = $('[data-offer-popup]');
    if (!el) return;
    const modal = makeModal(el, '[data-offer-close]');
    const KEY = 'cozfy_offer_seen';
    const expired = offerExpired(el.dataset.end);
    const openPopup = () => { if (!modal.isOpen()) { modal.open(); store.set(KEY, '1'); } };

    // The countdown bar re-opens the offer any time
    $$('[data-offer-open]').forEach((b) => b.addEventListener('click', () => { if (!offerExpired(el.dataset.end)) openPopup(); }));

    // CTA: on a product page, jump straight to the bundle picker
    const cta = $('[data-offer-cta]', el);
    cta.addEventListener('click', (e) => {
      const target = $('#bundles') || $('[data-product-form]');
      if (!target) return;
      e.preventDefault();
      modal.close();
      setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'center' }), 200);
    });

    if (expired || store.get(KEY)) return;
    setTimeout(openPopup, Number(el.dataset.delay || 2) * 1000);
  }

  /* ---------- Cart page quantity steppers ---------- */
  function initCartPage() {
    $$('[data-qty]').forEach((wrap) => {
      const input = $('input', wrap);
      const form = wrap.closest('form');
      $$('[data-qty-step]', wrap).forEach((btn) => btn.addEventListener('click', () => {
        input.value = Math.max(0, Number(input.value) + Number(btn.dataset.qtyStep));
        form.submit();
      }));
      input.addEventListener('change', () => form.submit());
    });
  }

  /* ---------- Mobile menu: close on outside tap ---------- */
  function initMenu() {
    const menu = $('[data-menu]');
    if (!menu) return;
    document.addEventListener('click', (e) => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initCountdowns();
    $$('[data-gallery]').forEach(initGallery);
    initCartNotice();
    $$('[data-pdp]').forEach(initProduct);
    initDelivery();
    initPopup();
    initCartPage();
    initMenu();
  });
})();
